var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 8.75005L9.94916 8.63582L9.92417 8.57959L9.87493 8.75005H9.99992ZM9.99992 8.75005H9.99993M9.99992 8.75005L9.99993 8.75006M9.99993 8.75005L10.0507 8.63582L10.0757 8.57959L9.94917 8.86431L9.99993 8.75006M9.99993 8.75005L9.99993 8.75006M9.99993 8.75005H10.1249H10.3078L10.5076 8.66123M9.99993 8.75006L10.0507 8.86431M10.0507 8.86431L10.5471 8.75005L10.5076 8.66123M10.0507 8.86431L10.1249 9.03133V9.03134L10.0507 8.86431ZM10.5076 8.66123L10.606 8.6175L10.4061 8.43275L10.5076 8.66123ZM2.90607 5.73401L3.0076 5.50556L9.1827 8.25005H8.87493V8.38687L2.90607 5.73401ZM9.99992 8.0661L9.79685 7.97585L9.72635 8.13449L9.69689 8.20078L9.99992 8.0661ZM9.59379 8.43275L9.49225 8.66123L9.59379 8.43275ZM17.0938 5.73401L11.1249 8.38687V8.25005H10.8172L16.9923 5.50556L17.0938 5.73401ZM10.1249 9.92563V17.4167H9.87493V9.92563L9.99991 9.98118L10.1249 9.92563Z",
    fill: "black",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.2584V5.7416C2.5 5.54401 2.61637 5.36495 2.79693 5.2847L9.79692 2.17359C9.92625 2.11613 10.0737 2.11613 10.2031 2.17359L17.2031 5.2847C17.3837 5.36495 17.5 5.54401 17.5 5.7416V14.2584C17.5 14.456 17.3837 14.6351 17.2031 14.7153L10.2031 17.8264C10.0737 17.8838 9.92625 17.8838 9.79692 17.8264L2.79693 14.7153C2.61637 14.6351 2.5 14.456 2.5 14.2584Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.75L13.4531 6.95137C13.6337 7.03162 13.75 7.21068 13.75 7.40827V10.4167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProducts);
export default __webpack_public_path__ + "static/media/sidebar-products.531cdfbca9dd4c79add5b94dc8d1c20d.svg";
export { ForwardRef as ReactComponent };